import { API_IDENTITY } from '../api/api.base';
import { bootstrapRequestConfig } from '../api/bootstrapRequestConfig';
import { ApiResponse, CurrentUserType } from '../types';

export const getCurrentUserRequest = async (): Promise<CurrentUserType> => {
	const response = await API_IDENTITY.get(
		'/api/user/current',
		{},
		{},
		bootstrapRequestConfig,
	);
	return response.value;
};

export const getCurrentUserRequestErrorHandling = async (): Promise<
	ApiResponse<CurrentUserType>
> => {
	const response = await API_IDENTITY.get(
		'/api/user/current',
		{},
		{},
		bootstrapRequestConfig,
	);
	return response;
};
